module.exports = __webpack_public_path__ + "6dbe536c8fb9bc2919ae9aa34a180cc4.png";